<template>
	<WorkIt>
		<Intro
			title="Dashboard Redesign"
			subtitle="Viewpost">
			<p>Viewpost provides unlimited free invoicing, streamlined payments and real-time cash flow management for over 100,000 companies. Based on user feedback, the design goal was to effectively create the center of a company’s financial well-being.</p>
		</Intro>

		<img class="m-auto mb-20 hidden sm:block box-shadow" src="/img/dashboard-main-min.png" srcset="/img/dashboard-main@2x-min.png 2x" alt="" />
		<img class="m-auto hidden sm:block" src="/img/dashboard-redesign-components-min.png" srcset="/img/dashboard-redesign-components@2x-min.png 2x" alt="" />

		<img class="m-auto sm:hidden box-shadow bg-white" src="/img/dashboard-main-m-min.png" srcset="/img/dashboard-main-m@2x-min.png 2x" alt="" />

		<FooterNav prev="/work" next="/work/ios-android-app"></FooterNav>
	</WorkIt>
</template>

<script>
import Intro from '@/components/Intro.vue';
import WorkIt from '@/components/WorkIt.vue';
import FooterNav from '@/components/FooterNav.vue';

import { mapMutations } from 'vuex';

export default {
	components: {
		Intro,
		WorkIt,
		FooterNav
	},
	methods: {
		...mapMutations([
			'APP_CLASS'
		])
	},
	created: function() {
		this.APP_CLASS('page-work work-detail dashboard-redesign');
	}
}
</script>